declare var _gaq: any;

export class ReadMore {
    private instances: NodeListOf<HTMLElement>;

    constructor() {
        this.instances = document.querySelectorAll("[data-read-more]") as NodeListOf<HTMLElement>;

        if (this.instances && this.instances.length > 0) {
            this.createModules();
        }
    }

    private createModules() {
        for (let i = 0; i < this.instances.length; i++) {
            const element: HTMLElement = this.instances[i];           
            const limit: string = `${element.getAttribute("data-read-more")}px`;
            const link: HTMLElement = document.createElement("a") as HTMLElement;

            link.innerText = "...read more";
            link.classList.add("readMOreLink"); 

            element.classList.add("transition");
            element.style.overflow = "hidden";
            element.style.height = limit;
            element.setAttribute("data-expanded", "false");

            element.appendChild(link);

            element.addEventListener("click", (e) => {
                const expanded: string = element.getAttribute("data-expanded");

                if (expanded === "false") {
                    e.stopPropagation();

                    element.setAttribute("data-expanded", "true"); 

                    const readMoreLink: HTMLElement = element.children[0] as HTMLElement;
                    readMoreLink.style.display = "none";

                    element.style.height = "auto";
                    const fullSize: number = element.clientHeight; 
                    element.style.height = limit;

                    setTimeout(() => {
                        element.style.height = `${fullSize}px`;
                    }, 1);

                    const analyticsName = element.getAttribute("data-read-more-analytics-name");
                    _gaq.push(["_trackEvent", "Interaction", `Read More (${analyticsName})`, document.URL, 0, false]);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/global/ReadMore.ts